import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { QuoteOrderLogModelType } from '@teinor/erp/types/company/order/quote/quoteOrder/quoteOrderLog'
import OrderStatusBar from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar'
import { displayDate } from '../../../../../../../../utils/globals/date'
import { Fragment } from 'react'
import { AdjustmentDeliveryNoteLogModelType } from '@teinor/erp/types/company/order/adjustmentDeliveryNote/adjustmentDeliveryNoteLog'
import { getOrderStatusBarType } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar/functions'
import { AdjustmentDeliveryNoteStatusInversed } from '@teinor/erp/types/company/order/adjustmentDeliveryNote'
import OrderStatusBarDropDown from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBarDropDown'
import { faCheckCircle, faPenCircle } from '@fortawesome/pro-light-svg-icons'

interface AdjustmentDeliveryNoteStatusBarProps extends DeliveryNoteCreateStatusBarProps {
}
const AdjustmentDeliveryNoteStatusBar: React.FC<AdjustmentDeliveryNoteStatusBarProps> = ({ orderStatus, OrderLogs }) => {
    const { statuses } = useCreateStatusBar({ orderStatus, OrderLogs })
    return (
        <OrderStatusBar statuses={statuses} currentOrderStatus={orderStatus} getOrderStatusBarType={getOrderStatusBarType}/>
    )
}

export interface DeliveryNoteCreateStatusBarProps {
    orderStatus: number
    OrderLogs: QuoteOrderLogModelType[]
}

const useCreateStatusBar = ({ OrderLogs }: DeliveryNoteCreateStatusBarProps) => {
    const { t } = useTwinTranslation()
    let statuses: TwinDictionary[] = []
    const dictOrderLogs: TwinDictionary = {}
    for (const log of OrderLogs) {
        if (!dictOrderLogs[log.logType]) {
            dictOrderLogs[log.logType] = [log]
        } else {
            dictOrderLogs[log.logType] = [...dictOrderLogs[log.logType], log]
        }
    }
    statuses.push({
        id: 0,
        name: t('draft', 'Borrador'),
        logType: 0,
        color: 'bg-gray-33',
        icon: faPenCircle,
        className: 'text-gray-33',
        extraClassName: 'border border-gray-33',
        renderMessage: dictOrderLogs[0]?.length ? <RenderLogMessage logs={dictOrderLogs[0] || []} /> : null
    })
    statuses.push({
        id: 1,
        name: t('processed', 'Procesado'),
        logType: 1,
        color: 'bg-green-43',
        icon: faCheckCircle,
        className: 'text-green-43',
        renderMessage: dictOrderLogs[1]?.length ? <RenderLogMessage logs={dictOrderLogs[1] || []} /> : null
    })
    
    return { statuses }
}

interface RenderLogMessageProps {
    logs: AdjustmentDeliveryNoteLogModelType[]
}

const RenderLogMessage: React.FC<RenderLogMessageProps> = ({ logs }) => {
    const { tVars } = useTwinTranslation()
    const renderMessage: JSX.Element[] = []
    for (const log of logs) {
        const extraDataParsed = JSON.parse(log.extraData || '{}')
        const options = { employeeTrigger: log.EmployeeTrigger?.fullname_short || '', date: displayDate(new Date(log.createdAt)), fullAssignedNumber: extraDataParsed.full_assigned_number || '','interpolation': { 'escapeValue': false }, }
        const dictOrderLogsMessages: TwinDictionary = {
            0: tVars('createdAdjustmentDeliveryNoteLogMessage', '{{employeeTrigger}} creó el albarán de regularización el {{date}}', options),
            1: tVars('acceptedDeliveryNoteLogMessage', '{{employeeTrigger}} marcó el albarán como aceptado el {{date}}', options),
        }
        if (dictOrderLogsMessages[log.logType]) {
            renderMessage.push(<div className='my-5' key={log.id} > {dictOrderLogsMessages[log.logType]} </div>)
        }
    }
    if (!renderMessage.length) {
        return null
    }
    return (<Fragment>{renderMessage}</Fragment>)
}

export const AdjustmentDeliveryNoteStatusBarNew: React.FC<AdjustmentDeliveryNoteStatusBarProps> = ({ orderStatus, OrderLogs }) => {
    const { statuses } = useCreateStatusBar({ orderStatus, OrderLogs })
    return (
        <OrderStatusBarDropDown statuses={statuses} currentOrderStatus={orderStatus} getOrderStatusBarType={getOrderStatusBarType} isAccepted={orderStatus === AdjustmentDeliveryNoteStatusInversed['accepted']} />
    )
}

export default AdjustmentDeliveryNoteStatusBar